import fullstory from '@/plugins/fullstory'
import Lambda from '@/services/Lambda'
import Store from '@/store/'
export default {
  async findOrder({ customerId, mmOrderId }) {
    try {
      let shopId = Store.getters['shop/getShopId']
      let token = Store.getters['auth/getAuthToken']
      let { data: existingOrder } = await Lambda.post('square_find_order', {
        shopId,
        customerId,
        mmOrderId,
        token,
      })
      return existingOrder
    } catch (error) {
      return Promise.reject('Could not find order')
    }
  },
  async createOrder(order) {
    try {
      let shopId = Store.getters['shop/getShopId']
      let token = Store.getters['auth/getAuthToken']
      let { data: newOrder } = await Lambda.post('square_create_order', {
        shopId,
        token,
        order,
      })
      return newOrder
    } catch (error) {
      return Promise.reject(error)
    }
  }, // createOrder

  // Call this function to send a payment token, buyer name, and other details
  // to the project server code so that a payment can be created with
  // Payments API
  async createPayment({
    squareToken,
    amount,
    orderId,
    mmOrderId,
    customerId,
    tipAmount = 0,
  }) {
    if (!squareToken || amount === undefined || !orderId) {
      throw new Error('Missing required parameters for Square payment')
    }

    let shopId = Store.getters['shop/getShopId']
    let token = Store.getters['auth/getAuthToken']

    let payload = {
      amount,
      sourceId: squareToken,
      orderId,
      tipAmount,
      token,
      mmOrderId,
      customerId,
      shopId,
    }

    try {
      fullstory.event('Creating Square Payment', { payload })
      const paymentResponse = await Lambda.post(
        'square_create_payment',
        payload
      )
      if (paymentResponse.status === 200) {
        return paymentResponse.data
      }
      fullstory.event('Square Payment Failed', { payload, paymentResponse })

      // Extract error message from axios response
      let errorMessage =
        paymentResponse.data?.body || 'Unknown error from Square'

      throw new Error(
        `Square Payment failed with status: ${paymentResponse.status}, message: ${errorMessage}`
      )
    } catch (error) {
      fullstory.event('Square Payment Exception', {
        payload,
        error: error.message,
        stack: error.stack,
      })

      throw new Error(
        `Exception encountered while creating Square payment: ${error.message}`
      )
    }
  },

  async retrieveOrder({ locationId, transactionId }) {
    let shopId = Store.getters['shop/getShopId']
    let token = Store.getters['auth/getAuthToken']

    try {
      let res = await Lambda.post('square_retrieve_order', {
        locationId,
        transactionId,
        shopId,
        token,
      })
      return res
    } catch (error) {
      throw new Error('Could not retrieve order')
    }
  },
}
